//----------------------------------------------SCROLL TOP-----------------------------------//
jQuery(document).ready(function ($) {
    $(window).scroll(function() {
        let getScrollTopBtn = $(".scroll-top");
        $(this).scrollTop() > 100 ? getScrollTopBtn.fadeIn() : getScrollTopBtn.fadeOut()
    });

    $(".scroll-top").click(function() {
        return $("body,html").animate({
            scrollTop: 0
        }, 800)
    });
});